import { combineReducers } from 'redux'

import auth from './auth.reducer'

const userReducers = combineReducers({
  auth,
})

export default userReducers
